import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import {
  DeploymentPointsResponseShape,
  TopBoxesResponseShape,
  TopBoxShape,
} from 'models/topboxes';

import {
  AcroHourData,
  RobotTraceChartData,
  TpRobotData,
  RobotHeatMapData,
  AlarmResponseShape,
  CameraRecordingShape,
} from 'models/dashboard';

type PairTopBoxWithRobotPropType = {
  url: string;
  robot_uuid: string;
};

export type FiltersPropsShape = {
  customer_uuid?: string;
  site_uuid?: string;
  pen_uuid?: string;
};

export const TopBoxesApi = createApi({
  reducerPath: 'topboxesApi',
  tagTypes: ['topboxes', 'topbox', 'robot-view'],
  baseQuery,
  endpoints: (builder) => ({
    getTableData: builder.query<TopBoxesResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['topboxes'],
    }),
    pairTopBoxWithRobot: builder.mutation<string, PairTopBoxWithRobotPropType>({
      query: ({ url, robot_uuid }) => ({
        url: url,
        method: 'POST',
        body: {
          robot_uuid,
        },
      }),
      invalidatesTags: ['topboxes', 'topbox'],
    }),
    unPairTopBoxWithRobot: builder.mutation<
      string,
      PairTopBoxWithRobotPropType
    >({
      query: ({ url, robot_uuid }) => ({
        url: url,
        method: 'POST',
        body: {
          robot_uuid,
        },
      }),
      invalidatesTags: ['topboxes', 'topbox'],
    }),
    getTopBox: builder.query<TopBoxShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['topbox'],
    }),
    getDeploymentPoints: builder.query<DeploymentPointsResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getRobotView: builder.query<TpRobotData, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['robot-view'],
    }),
    getRobotTraceChart: builder.query<RobotTraceChartData, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getAcroHourData: builder.query<AcroHourData, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getRobotHeatMapData: builder.query<RobotHeatMapData, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getAlarmsData: builder.query<AlarmResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
    }),
    getCameraRecordingState: builder.query<CameraRecordingShape, string>({
      query: (url) => ({
        url: url,
      }),
    }),
  }),
});

export const {
  useGetTableDataQuery,
  useGetTopBoxQuery,
  useGetDeploymentPointsQuery,
  useGetRobotViewQuery,
  useGetRobotTraceChartQuery,
  useGetAcroHourDataQuery,
  useGetRobotHeatMapDataQuery,
  useGetAlarmsDataQuery,
  useGetCameraRecordingStateQuery,
  usePairTopBoxWithRobotMutation,
  useUnPairTopBoxWithRobotMutation,
} = TopBoxesApi;
